import { useEffect } from "react";

export const localCalendarDate = (day = new Date()) => `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, "0")}-${String(day.getDate()).padStart(2, "0")}`;

export function purchaseEta(row, today = new Date()) {
  if (["Received", "Cancelled"].includes(row.status)) return row.status;
  if (!row.eta_at) return row.status === "Ordered" ? "Ordered · ETA not confirmed" : (row.status === "open" ? "To Order" : row.status || "Requested");
  const date = String(row.eta_at).slice(0, 10);
  const localToday = localCalendarDate(today);
  const overdue = row.status === "Ordered" && date < localToday;
  return `${overdue ? "OVERDUE · " : ""}${date === localToday ? "Expected today" : `Expected ${new Date(`${date}T12:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short" })}`}`;
}


export const purchaseTimezoneQuery = () => `utc_offset_minutes=${-new Date().getTimezoneOffset()}`;

export function usePurchaseLocalMidnight(onNewDay, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    let timer;
    let lastDay = new Date().toDateString();
    const checkDay = () => {
      const day = new Date().toDateString();
      if (day !== lastDay) { lastDay = day; onNewDay(); }
    };
    const schedule = () => {
      const now = new Date();
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      timer = window.setTimeout(() => { checkDay(); schedule(); }, midnight.getTime() - now.getTime() + 25);
    };
    // Background tabs may delay timers: refresh on return if the local day changed.
    const onVisible = () => { if (!document.hidden) checkDay(); };
    schedule();
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", checkDay);
    return () => { window.clearTimeout(timer); document.removeEventListener("visibilitychange", onVisible); window.removeEventListener("focus", checkDay); };
  }, [onNewDay, enabled]);
}
